import isNull from './isNull'

const MaskPhoneNumber = (number, command = 'generatemask') => {
  if (command === 'generatemask') {
    if (isNull(number)) return number
    var x = number.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
    number = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
    return number
  } else {
    let purenumber = number.replace(/[^\d]/g, '').slice(0, 10)
    return purenumber
  }
}

// const MaskPhoneNumber = (number, command = 'generatemask') => {
//   if (isNull(number) || number.trim() === "") return ""; // Allow empty input

//   if (command === 'generatemask') {
//     // Remove all non-digit characters
//     let normalizedNumber = number.replace(/\D/g, '');

//     // Ensure the number starts with 1 if not already
//     if (!normalizedNumber.startsWith('1')) {
//       normalizedNumber = '1' + normalizedNumber;
//     }

//     // Match groups: 1(first digit), 2(area code), 3(first 3 digits), 4(last 4 digits)
//     let x = normalizedNumber.match(/(\d{1})(\d{0,3})(\d{0,3})(\d{0,4})/);
//     // Build the formatted number with +1 prefix
//     number = !x[2] ? '+' + x[1] : '+' + x[1] + '(' + x[2] + (x[3] ? ') ' + x[3] + (x[4] ? '-' + x[4] : '') : '');

//     // Trim any trailing spaces or incomplete formatting
//     number = number.trim().replace(/\s+$/, '');
//     return number;
//   } else {
//     // For pure number format, ensure it starts with 1
//     let purenumber = number.replace(/[^\d]/g, '');
//     if (!purenumber.startsWith('1')) {
//       purenumber = '1' + purenumber;
//     }
//     return purenumber.slice(0, 11); // Limit to 11 digits (1 + 10 digits)
//   }
// }

export default MaskPhoneNumber


